import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'

import {
  MACBOOKS_CATEGORIES,
  ProductCategory,
} from '~/scopes/product/constants'

import {
  STEP_ILLUSTRATION_AIRPODS,
  STEP_ILLUSTRATION_GENERIC,
  STEP_ILLUSTRATION_IPAD,
  STEP_ILLUSTRATION_LAPTOP,
  STEP_ILLUSTRATION_MACBOOK,
  STEP_ILLUSTRATION_SERVICES,
  STEP_ILLUSTRATION_SMARTPHONE,
} from '../CustomizationFunnel.constants'

import type { DesktopIllustration } from './types'

export const getStepIllustrations = (
  product: GetProductResponse,
): Record<string, DesktopIllustration> => {
  let variantIllustrations = {}

  if (
    [ProductCategory.SMARTPHONE, ProductCategory.SMARTPHONE_BOX].includes(
      product.tracking.categoryId,
    )
  ) {
    variantIllustrations = STEP_ILLUSTRATION_SMARTPHONE
  } else if (MACBOOKS_CATEGORIES.includes(product.tracking.categoryId)) {
    variantIllustrations = STEP_ILLUSTRATION_MACBOOK
  } else if (product.tracking.categoryId === ProductCategory.AIRPODS) {
    variantIllustrations = STEP_ILLUSTRATION_AIRPODS
  } else if (product.tracking.categoryId === ProductCategory.IPAD) {
    variantIllustrations = {
      ...STEP_ILLUSTRATION_GENERIC,
      ...STEP_ILLUSTRATION_IPAD,
    }
  } else if (product.tracking.categoryId === ProductCategory.LAPTOP) {
    variantIllustrations = {
      ...STEP_ILLUSTRATION_GENERIC,
      ...STEP_ILLUSTRATION_LAPTOP,
    }
  } else {
    variantIllustrations = STEP_ILLUSTRATION_GENERIC
  }

  return {
    ...variantIllustrations,
    ...STEP_ILLUSTRATION_SERVICES,
  }
}
